/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as eventService from '../services/eventService'
import * as stringParser from '../util/string.util'
import * as dateUtil from '../util/date.util'
import * as utilService from '../services/utilService'
// import Joinnowpopup from './sub_components/joinnowpopup'
// import Loginpopup from './sub_components/loginpopup'
import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
import AboutUs from './sub_components/aboutUs'
import BettingRules from './sub_components/bettingRules'
import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
import PrivacyPolicy from './sub_components/privacyPolicy'
import TermsAndConditions from './sub_components/termsAndConditions'
import ContactUs from './sub_components/contactUs'
import RulesRegulations from './sub_components/rulesregulations'
import CookiePolicy from './sub_components/cookiepolicy'
import HowToPlay from './sub_components/howtoplay'
import ResponsibleGaming from './sub_components/responsiblegaming'
import UnderMaintenance from './under_maintenance';



// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import { DOMAINDISPLAY } from '../configs/apkFileName';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
// import Maintanence from './sub_components/maintanence'
// import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import SplashScreenModal from './sub_components/splashScreenModal';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

 let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class LoginB2C extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            inMaitanenceMessage: '',
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection : "",
            clientWidth: document.documentElement.clientWidth,
            accordionOpen: false,
            showSplashScreenPopup: true,
            affCode:""
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }
    componentWillMount() {
        utilService.checkMaintainanceCall().then((res) => {
            if (res.isSuccess && !!res.items && res.items.isMaintenance) {
                this.setState({
                    inMaitanence: true,
                    inMaitanenceMessage: res.items
                })
            }
        })
    }

    async componentDidMount() {
        localStorage.removeItem('videoSplashScreenVisited');
        localStorage.removeItem("homeData")
        localStorage.removeItem("userAuthDetail")
        localStorage.removeItem("tokenData")
        if(window.location.pathname.indexOf('affiliate') === 1){
            const affCd = this.props.match.params.affCode;
            this.setState({affCode:affCd});
        } else {
            const innersectionid = this.props.match.params.innersectionid;
            if(!!innersectionid){
                this.toggleSelectedSection(innersectionid);
            }
        }
        
        eventService.getBaseHomeData().then((res) => {
            let homeData = this.parseBook(res)
            localStorage.setItem('homeData', JSON.stringify(homeData))
            localStorage.setItem('isBaseData', "true")
        })
    }

    

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    parseBook(data) {
        !!data && data.length > 0 && data.forEach((mkt, i) => {
            // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
            let eventMeta = {}
            eventMeta.hasBookMaker = !!mkt.metadata && !!mkt.metadata.hasBookMaker && mkt.metadata.hasBookMaker === "True" ? "true" : "false"
            eventMeta.hasSession = !!mkt.metadata && !!mkt.metadata.hasSession && mkt.metadata.hasSession === "True" ? "true" : "false"
            eventMeta.hasTv = !!mkt.metadata && !!mkt.metadata.hasTv && mkt.metadata.hasTv === "True" ? "true" : "false"
            let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz(mkt.metadata.book) : null
            if (mkt.eventType.id === "300") {
                data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(mkt.catalogue.marketName)
                data[i].symbolType = !!mkt.metadata && !!mkt.metadata.symbol_type ? mkt.metadata.symbol_type : null
                data[i].eventId = mkt.event.id
                data[i].eventName = mkt.event.name
                data[i].competitionName = mkt.competition.name
            }
            // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
            data[i].metadata = {}
            data[i].metadata.book = book
            data[i].metadata.eventMeta = eventMeta
            // if(!!market_end_time){
            //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
            //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
            // }
        })
        return data
    }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]:false })
        
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    toggleSelectedSection(name){
        this.setState({selectedSection: this.state.selectedSection === name ? "" : name});
    }
    openLoginModal(){
        document.getElementById('btnLoginb2cLogin').click();
    }
    accordionToggle(){
        this.setState({accordionOpen : !this.state.accordionOpen})
    }
    hideSplashScreenPopup(){
        this.setState({showSplashScreenPopup: false});
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <>
            {
              !this.state.inMaitanence?
            <div className="radheexch radheexchlogin bg-white-login">            
            
            <Loginb2cHeader history={this.props.history} selectedSection={this.state.selectedSection} toggleSelectedSection={(view) => this.toggleSelectedSection(view)} showSweetAlert={(options) =>this.props.showSweetAlert(options)} notify={this.props.notify} affCode={this.state.affCode}></Loginb2cHeader>
            <div className='login-mar-top100 mb-0'>
            {/* <LoginSportsThumbnailList showPopup={(e) => { this.showPopup("Login")}} ></LoginSportsThumbnailList> */}
            <section className='about' id='innersection'>
                {this.state.selectedSection === "" ?
                    <LoginSportsThumbnailList showPopup={(e) => { this.openLoginModal()}} ></LoginSportsThumbnailList>
                    : this.state.selectedSection === "aboutus" ? 
                    <AboutUs></AboutUs>
                    : this.state.selectedSection === "termandconditions" ? 
                    <TermsAndConditions></TermsAndConditions>
                    : this.state.selectedSection === "privacypolicy" ? 
                    <PrivacyPolicy></PrivacyPolicy>
                    : this.state.selectedSection === "bettingrules" ? 
                    <BettingRules></BettingRules>
                    : this.state.selectedSection === "contactus" ? 
                    <ContactUs></ContactUs>
                    : this.state.selectedSection === "rulesregulations" ? 
                    <RulesRegulations></RulesRegulations>
                    : this.state.selectedSection === "cookiepolicy" ? 
                    <CookiePolicy></CookiePolicy>
                    : this.state.selectedSection === "howtoplay" ? 
                    <HowToPlay></HowToPlay>
                    : this.state.selectedSection === "responsiblegaming" ? 
                    <ResponsibleGaming></ResponsibleGaming>
                    : this.state.selectedSection === "depositsandwithdrawals" && 
                    <DepositsAndWithdrawals></DepositsAndWithdrawals>
                }
            </section>

            {/* NEW LOGIN B2C START */}
            {this.state.selectedSection === "" &&
            <>
            <section className='accordion-mainbox'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='accordion-innerbox'>
                                <div className='accordion-head' onClick={()=> this.accordionToggle()}>
                                    <h1 className="accordion-title">Indian online casinos games</h1>
                                    <div className='accordion-arrow'>
                                        {/* <i className="fa fa-angle-up" aria-hidden="true"></i> */}
                                        <i className={`fa fa-angle-${this.state.accordionOpen?'up':'down'}`} aria-hidden="true"></i>
                                    </div>
                                </div>
                                {this.state.accordionOpen && 
                                    <div className='accordion-body seofooter'>
                                        <div className='accordion-boxheight accordion-box-inner'>
                                        <div className='col-12'>
                                        <h1>Indian online casinos games </h1>
                                        <p>
                                        Here at {DOMAINDISPLAY.name}, we invite you to discover the brand-new world of real money online gaming. We
        provide you with the most excellent online casino gaming experience in India. You should always
        leave everything behind if you want to fully immerse yourself in the world of online casino games
        in India. The previous several years have seen far too many changes in online gaming. And we
        seek a location where such an encounter might satisfy our general want to gamble. To provide
        you access to that experience, we are here. Want to engage in online sports betting in India? We
        provide odds on practically all sports and constantly strive to offer you more remarkable and
        better experiences. </p>
        <p>India has seen rapid development in the current continuing epidemic of online casino games.
        Since the epidemic began in India, more and more individuals are starting to engage in online
        gambling, and we can be sure that this trend will continue to expand over time. Additionally, the
        number of online casino gaming platforms and the variety of betting games are growing faster
        than ever. Check out other dice games for gambling to increase your chances of success and
        adventure. </p>
        <p>Consider trying out some online card games. Perhaps you're trying to find an online casino
        focusing on card games. We'll introduce you to the top betting sites for such an occasion. You will
        have complete gambling freedom to choose the ideal website for your needs. Your preferences,
        such as the promotions and incentives they provide to you, might help you distinguish between
        them.</p>

        <h2>The best welcome bonus at casinos</h2>
        <p>You may get a variety of online bonuses from various online casinos as a way to draw customers
        to them. If you want, you can take advantage of that chance. It is an entirely free service that you
        may take advantage of. New Online gamblers may benefit from that welcome bonus to provide
        more delight in gaming and make more profit with their money.</p>
        <p>Make sure you pick an online casino with the finest welcome bonus when choosing one.
        Depending on the casino, you may get a big welcome bonus with a high or low welcome bonus
        with low wagering requirements.</p>
        <p>To entice new players, all online casinos provide some welcome casino bonus. A welcome bonus
        is not required to be used. Said it's an offer. It doesn't cost you anything, and as players, we can
        benefit from this by using the welcome casino bonus to increase our enjoyment and financial
        gains.</p>
        <p>Make sure you choose the finest casino bonus before picking which online casino to play at.
        Every casino bonus is unique. While some casinos provide a lesser bonus sum and a reduced
        wagering requirement, certain casinos will give you a huge bonus with a high wagering
        requirement. Select the parameters that are ideal for you and enjoy your time playing online
        poker with us. And we'll ensure to maximize your enjoyment of online gambling by using our
        expertise and in-depth knowledge of the industry's terms. For us, it's more than just a company. It
        is an excellent approach to delight and thrills our users. To maintain this zeal for online casino
        games, we will continue to be enthusiastic about bringing our player's ever-increasing advances
        in online gambling.
        </p>

        <h3>Gambling games</h3>
        <p>Casinos will offer you many exciting games, including:</p>
            <p className='ml-2'>● Card games</p>
            <p className='ml-2'>● Roll the dice</p>
            <p className='ml-2'>● In baccarat</p>
            <p className='ml-2'>● Internet Poker</p>
            <p className='ml-2'>● Bingo</p>

            <p>And many more!</p>

        <h3>Play with Indian Currency</h3>
        <p>The internet gaming market is enormous. T tens of thousands of websites provide casino
        platforms, but none are secure or authorized to allow you to withdraw real money using
        reputable payment methods. Additionally, it isn't easy to use rupees as money. We're here to help
        you discover the most significant Indian market so you may get the top sports and gambling card
        games for fast cash sent into your bank account.</p>

        <p>Our goal is to provide its Indian players a place to play real money online casino games. 1xBook
        guarantees you a fantastic assortment of games with thorough details on each game.</p>

        <p>You may play your favorite game for entertainment purposes or to earn real money. You need a
        laptop or desktop computer to play gambling dice games.</p>

        <p>To participate in our brain teaser activities, create a new account and register with us. You only
        need to follow the easy steps and deposit money to your account to play real money games.</p>

        <p>On the other hand, you may choose the demo option in the game you are playing if you don't
        want to commit money for the first time.</p>

        <p>However, each time a player signs up with us, they may take advantage of a 100% casino bonus
        on their first deposit and be eligible to participate in ongoing tournaments and earn free spins.
        Make sure you play with confidence.</p>

        <p>You won't need to be concerned about somebody taking your personal information since we
        employ cutting-edge encryption software to keep your information private and secure from
        hackers.</p>

        <p>Since we are completely licensed and regulated to provide dependable real money games and
        services, you can feel safe playing online casino games with us.</p>

        <p>Additionally, we firmly support gaming responsibly and are delighted to have discovered India's
        most incredible casino platform. Playing games for real money is enjoyable, but we will do our
        best to help if you want assistance.</p>

        <p>In the cosmic beyond, there is never-ending pleasure and enjoyment. 1xBook has the most
        exciting game selection, great promos, and more. The best place to play video games is 1xBook.</p>

        <p>Finally, don't hesitate to contact us if you have any questions. Our knowledgeable customer
        service staff is here to answer any questions. 24/7 customer assistance is available from us.
        </p>

        <h2>Introduction Bonuses at These Casinos</h2>
        <p>Welcome bonuses are a tactic used by these online bookmaker casinos to attract clients and
        pique their curiosity about the live casino activities. Before considering the welcome bonuses,
        these casinos offer, be sure they accept Indian clients and Indian rupees.</p>
        <p>After entering your account and playing, these online casinos will offer you welcome bonuses.
        1xBook provides a variety of introductory bonuses for their live casino events, ranging in value
        from 100% matched bonuses up to Rs. 60,000 for Cricket Roulette. In comparison, you may get
        an Rs. 3000 welcome bonus credit at the Bollywood Blackjack table.</p>
        <p>High-end Welcome Casino Bonuses provided by {DOMAINDISPLAY.name} have established a new benchmark.
        After making their initial minimal INR 100 investment, all new users of the online casino platform
        get a 100% casino bonus. Because it is a one-time promotion, you should make the most of it.</p>
        <p>These are a few welcome incentives from India's most well-known and reputable online
        bookmakers. We advise you to click on the inbound links that will take you directly to the terms
        and conditions page for welcome bonuses if you want to learn more about the welcome bonuses
        offered by these casinos.</p>

        <h2>How to maximize your profits while betting online in India?</h2>
        <p>Playing online casino games, slot machines, and other games may all be a tonne of fun. They will
        significantly increase your adrenaline levels, and you may feel inclined to spend more money
        than is reasonable on these games. You must always keep fun out of these situations and
        concentrate on your abilities. You need to have good betting abilities to increase your chances of
        winning. You can't always rely on good fortune.</p>
        <p>Know your sport well and out before placing a wager. Learn anything that seems significant and
        may aid you in making accurate forecasts. For instance, if a football game is about to start, find
        out who is participating, the starting lineup, the player types, the strengths and weaknesses of
        the teams and the players, and their past performances. You may continue producing accurate
        forecasts ahead of time with the help of all this knowledge.</p>
        <p>Examine your chances of winning the wager at several bookies. You must diversify your contacts
        since you can't always rely on one. Gain as many promos as possible, and use the site prediction
        features. Do not rely on online predictions of winners. Create your forecasts to be specific.</p>
        <p>Visit several betting websites to review betting deals, promotions, bonuses, incentives, welcome
        bonuses, and the like. Open several betting accounts to make the most money from online
        betting in India. But keep in mind to exercise discipline and refrain from impulsively placing bets.
        Before making a wager, think it out thoroughly. Never wager with money you can't afford to lose.</p>

        <h2>How can I deposit and withdraw funds while betting online?</h2>
        <p>Deposit on the online betting site before you may place bets or take advantage of welcome
        incentives. Navigate to the cashier portion of an online betting site to make a deposit. Examine
        the forms of payment they take and see whether you have any of them. The most popular
        payment options accepted by Indian online bookmakers are Paytm, Google Pay, debit/credit
        cards, net banking, UPI, and others. All bookies allow international payment options, including
        Mastercard and Visa, worldwide. It's best to verify beforehand since approved payment methods
        differ from site to site.</p>
        <p>Before you may withdraw money from online betting sites, several criteria, restrictions, and
        demands must be satisfied. You must submit a few documents to complete your KYC and ID
        verification. Compared to deposit payment methods, withdrawal payment methods might
        sometimes have fewer payment options. The minimum and maximum withdrawal amounts vary
        across various online bookmakers.</p>

        <h2>Various forms of internet betting</h2>
        <p>Most online bets are made on sports or athletic events, including basketball, association football,
        horse racing, and cricket. Various bets may be made on award ceremonies, including the
        Grammys, Oscars, Emmys, and others. Internet betting has been made more engaging to draw in
        more players. So far, it has been confirmed to be a thriving sector that generates billions of
        dollars annually. Learn about the sports events and sports you may bet on before placing an
        online wager on any sporting event. What are the games with the lowest winning odds and the
        most often played ones?</p>

        <h3>cricket betting</h3>
        <p>In India, cricket betting may be the most popular internet gambling. With the advent of the Indian
        Premier League, cricket betting became ten times more popular, and now, it enjoys significant
        client engagement throughout ODI, Twenty20, and Test Matches.</p>
        <p>Cricket is an unpredictable game, which makes it difficult to make accurate forecasts, but it also
        makes it very entertaining. Learn about the strengths and weaknesses of the players on both
        sides, the records of both teams, the spin and speed combinations, the present form of the
        players, the squad composition, and the pitch report to broaden your understanding of cricket
        betting and boost your chances of winning.</p>
        <p>Determine the game's worth and choose the best bookies to put your bets on. Given the number
        of active online cricket betting sites, you must choose wisely based on each one's minimal odds,
        benefits, and promotions. Before a cricket match, the best advice is to go through all of the top
        Indian online betting sites, review the latest news and betting trends, and then choose the one
        that will be the safest and most advantageous.</p>
        <p>On their website, {DOMAINDISPLAY.name} includes a section devoted to all cricket-related online betting and
        casino events. They provide intriguing deals with their single and combination betting systems
        and {DOMAINDISPLAY.name}. Betting on the Tamil Nadu Premier League is also available since they serve an
        Indian audience.</p>
        <p>These are a few of the cricket betting promotions that are currently available on various betting
        platforms.</p>

        <h3>Soccer betting</h3>
        <p>Soccer, or association football, is a global sport that is very well-liked all over the globe. Millions
        of people watch competitions like the UEFA Euros, World Cup, UEFA Champions League, and
        Premier League. Several online betting services also host tournaments to accurately predict the
        number of goals each side scores and who will win the game after 90 minutes. Some online
        bookmakers even provide advice to assist users in making accurate predictions.</p>
        <p>However, you can't always rely on these forecasts; you must also be familiar with the game. Learn
        about the playing styles, individual and team strengths and weaknesses, and who is most likely to
        score a goal, among other things. You can create accurate forecasts if you sufficiently understand
        all the game's contributing components.</p>
                                    
        <h3>equine betting</h3>
        <p>You may have seen movie horse betting scenes where the wealthy, royalty and regular people
        predict which horse will win. Horse betting competitions are a unique event in rich countries and
        a fantastic way for people from the middle and lower-income classes to earn additional money by
        making the correct predictions</p>
        <p>Knowing a horse's present form and health, as well as how they have fared in past races and how
        the event ranks them, are necessary for making a good horse betting prediction. You may always
        visit 1xBook.com if you want to wager on horses or horse races. 1xBook provides betting on horse
        races in local and foreign markets.</p>

        <h3>Kabaddi betting</h3>
        <p>The Pro Kabaddi League event has increased interest in and interest in Kabaddi's all-Indian,
        dynamic, and fascinating sport. Why not try Kabaddi Betting if you are an enthusiastic follower of
        the Pro Kabaddi League and have a solid understanding of Kabaddi's rules and playing style? Use
        your forecasts to your advantage and pick the best wagers on the match. The additional funds
        from the victory will appear excellent on your bank statement.</p>
        <p>If you're interested in betting on Kabaddi, check out 1xBook. That has a wide range of Kabaddi
        betting choices.</p>

        <h3>Basketball wagers</h3>
        <p>Basketball wagering is mainly concentrated on the NBA, an international phenomenon. People
        worldwide have expressed their admiration for the NBA, which has played a significant role in
        American culture. Online wagering on these events is relatively standard, and even fantasy
        basketball attracts some interest from bettors. The Euroleague is a different basketball
        competition that is well-liked.</p>
        <p>You may visit 1xBook to place a wager on Basketball sports events. 1xBook offers you the
        opportunity to wager on events including WNBA friendlies, the NBA, Euroleague, Liga ACB
        (Spain), and the BBL (Germany).</p>

        <h2>Others</h2>
        <p>Online bookmakers develop a particular platform for wagering on athletic events like the
        Olympics, World Championships, Football World Cup, Cricket World Cup, and more when they
        take place. You may browse the live Olympic betting homepage provided by {DOMAINDISPLAY.name} online
        betting platform, make your prediction, and place bets on the currently playing sports. There are
        several additional forms of online betting, such as cycling, Formula 1, boxing, wrestling,
        badminton, hockey, esports, and more.</p>

        <h2>Advice & Methods</h2>
        <p>If you're new to online betting, you must learn to regulate your emotions and keep them out of
        your play and wagering. Make intelligent estimates if you want to take a chance on losing your
        money. Know what you are betting on and how many wins you can tolerate losing and winning.
        After a game of online betting, you do not want to be left sitting on anything.</p>
        <p>Do thorough research before placing a wager and look at historical patterns and results.
        Consider learning more about online betting than simply the basics. For a sample, if you are
        placing a bet on an Indian Premier League match, look into the prior results of both teams, as well
        as the runs and actions of certain cricket players. You'll be able to place a more educated wager
        and improve your chances of winning.</p>
        <p>We advise you to visit and explore the websites before making bets if you want to use one of the
        top Indian online betting sites mentioned above. You won't have to waste time looking for
        possibilities and lose the necessary time that you might be used to placing bets.</p>
        <p>We also suggest you go through the patterns, outcomes, and other data shown on the betting
        websites. It will be simpler for you to play games and make money if you are more
        knowledgeable about the most recent events in online gambling. Verify their legitimacy and how
        they conduct financial transactions.</p>
        <p>Open several betting accounts and take advantage of bonus and incentive offers. Before taking
        the incentives, carefully review the terms and conditions. Be as acquainted with games as you
        can with your odds of winning, and avoid gambling with funds you cannot afford to lose. You can
        never predict whether or not luck will be on your side. Calculate the likelihood that you will win
        vs. lose.</p>
        <p>One of the most meaningful elements of online gambling is the time of bet placement. If there are
        any active bets, check them out. To gain fascinating possibilities and prizes, you must be well
        informed about your game. Look for tempting wagering opportunities. When betting online,
        single bets are the most popular choice. Although there are dangers and benefits unique to this
        situation, winning is more straightforward. To win single bets, you only need a thorough
        understanding of the game and a dash of good fortune.</p>
        <p>Keep a record of your wagering choices across different sites. You'll place better bets if you keep
        a record of all your wagers, forecasts, and information on the game's status and specifics.
        Additionally, you may monitor your spending and determine which kind of online betting will bring
        you the most money.</p>
        <p>Talk about the games with other online gamblers and sports fans. They'll increase your
        understanding, but you may also gain from their comments and counsel.</p>

        <h2>The evolution of internet betting</h2>
        <p>Sports betting has been around for a very long time, and it possibly got its start with gladiator
        fights in ancient Greece. Online gambling started to become popular soon after the internet was
        invented. The three most popular types of internet gambling—poker, casinos, and sports
        betting—have brought a lot of money into their systems. Online sports betting is the most
        common type of gambling available globally. You can gain money if you can correctly forecast a
        game, wager on the result, and make good predictions.</p>
        <p>Online betting is shared globally, but it is trendy in sports like football, American football,
        basketball, horse racing, and wrestling. You may utilize your understanding of these games to
        gain money if you like sports and want to start placing bets online.</p>
        <p>Additionally, there are several scandals and issues surrounding online betting. Before placing a
        wager on a sport, it would be prudent to do a considerable study about its history. While placing
        bets online, you do not want the threat of loss to hang over your head.</p>

        <h2>Legality</h2>
        <p>Before engaging in internet gambling, you should familiarise yourself with your state laws since
        the state governs gaming. The rules governing gambling and betting in India differ from state to
        state. To prevent engaging in any unlawful acts with knowledge, it is preferable to do some
        research. Casinos and gambling, both online and off, are permitted in several states, including
        Goa and Sikkim, and they significantly boost those states' economies.</p>
        <p>We may infer that internet gambling is undoubtedly legal in India on a greater scale. Only a few
        states have laws limiting internet gambling, betting, and casinos out of all those in the union.
        However, it is best to confirm the legitimacy of these online gambling sites before putting your
        bets if you want to be certain.</p>



        </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
                <section className='seofooter d-none'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>Indian online casinos games </h1>
                                <p>
                                Here at {DOMAINDISPLAY.name}, we invite you to discover the brand-new world of real money online gaming. We
provide you with the most excellent online casino gaming experience in India. You should always
leave everything behind if you want to fully immerse yourself in the world of online casino games
in India. The previous several years have seen far too many changes in online gaming. And we
seek a location where such an encounter might satisfy our general want to gamble. To provide
you access to that experience, we are here. Want to engage in online sports betting in India? We
provide odds on practically all sports and constantly strive to offer you more remarkable and
better experiences. </p>
<p>India has seen rapid development in the current continuing epidemic of online casino games.
Since the epidemic began in India, more and more individuals are starting to engage in online
gambling, and we can be sure that this trend will continue to expand over time. Additionally, the
number of online casino gaming platforms and the variety of betting games are growing faster
than ever. Check out other dice games for gambling to increase your chances of success and
adventure. </p>
<p>Consider trying out some online card games. Perhaps you're trying to find an online casino
focusing on card games. We'll introduce you to the top betting sites for such an occasion. You will
have complete gambling freedom to choose the ideal website for your needs. Your preferences,
such as the promotions and incentives they provide to you, might help you distinguish between
them.</p>

<h2>The best welcome bonus at casinos</h2>
<p>You may get a variety of online bonuses from various online casinos as a way to draw customers
to them. If you want, you can take advantage of that chance. It is an entirely free service that you
may take advantage of. New Online gamblers may benefit from that welcome bonus to provide
more delight in gaming and make more profit with their money.</p>
<p>Make sure you pick an online casino with the finest welcome bonus when choosing one.
Depending on the casino, you may get a big welcome bonus with a high or low welcome bonus
with low wagering requirements.</p>
<p>To entice new players, all online casinos provide some welcome casino bonus. A welcome bonus
is not required to be used. Said it's an offer. It doesn't cost you anything, and as players, we can
benefit from this by using the welcome casino bonus to increase our enjoyment and financial
gains.</p>
<p>Make sure you choose the finest casino bonus before picking which online casino to play at.
Every casino bonus is unique. While some casinos provide a lesser bonus sum and a reduced
wagering requirement, certain casinos will give you a huge bonus with a high wagering
requirement. Select the parameters that are ideal for you and enjoy your time playing online
poker with us. And we'll ensure to maximize your enjoyment of online gambling by using our
expertise and in-depth knowledge of the industry's terms. For us, it's more than just a company. It
is an excellent approach to delight and thrills our users. To maintain this zeal for online casino
games, we will continue to be enthusiastic about bringing our player's ever-increasing advances
in online gambling.
</p>

<h3>Gambling games</h3>
<p>Casinos will offer you many exciting games, including:</p>
    <p className='ml-2'>● Card games</p>
    <p className='ml-2'>● Roll the dice</p>
    <p className='ml-2'>● In baccarat</p>
    <p className='ml-2'>● Internet Poker</p>
    <p className='ml-2'>● Bingo</p>

    <p>And many more!</p>

<h3>Play with Indian Currency</h3>
<p>The internet gaming market is enormous. T tens of thousands of websites provide casino
platforms, but none are secure or authorized to allow you to withdraw real money using
reputable payment methods. Additionally, it isn't easy to use rupees as money. We're here to help
you discover the most significant Indian market so you may get the top sports and gambling card
games for fast cash sent into your bank account.</p>

<p>Our goal is to provide its Indian players a place to play real money online casino games. 1xBook
guarantees you a fantastic assortment of games with thorough details on each game.</p>

<p>You may play your favorite game for entertainment purposes or to earn real money. You need a
laptop or desktop computer to play gambling dice games.</p>

<p>To participate in our brain teaser activities, create a new account and register with us. You only
need to follow the easy steps and deposit money to your account to play real money games.</p>

<p>On the other hand, you may choose the demo option in the game you are playing if you don't
want to commit money for the first time.</p>

<p>However, each time a player signs up with us, they may take advantage of a 100% casino bonus
on their first deposit and be eligible to participate in ongoing tournaments and earn free spins.
Make sure you play with confidence.</p>

<p>You won't need to be concerned about somebody taking your personal information since we
employ cutting-edge encryption software to keep your information private and secure from
hackers.</p>

<p>Since we are completely licensed and regulated to provide dependable real money games and
services, you can feel safe playing online casino games with us.</p>

<p>Additionally, we firmly support gaming responsibly and are delighted to have discovered India's
most incredible casino platform. Playing games for real money is enjoyable, but we will do our
best to help if you want assistance.</p>

<p>In the cosmic beyond, there is never-ending pleasure and enjoyment. 1xBook has the most
exciting game selection, great promos, and more. The best place to play video games is 1xBook.</p>

<p>Finally, don't hesitate to contact us if you have any questions. Our knowledgeable customer
service staff is here to answer any questions. 24/7 customer assistance is available from us.
</p>

<h2>Introduction Bonuses at These Casinos</h2>
<p>Welcome bonuses are a tactic used by these online bookmaker casinos to attract clients and
pique their curiosity about the live casino activities. Before considering the welcome bonuses,
these casinos offer, be sure they accept Indian clients and Indian rupees.</p>
<p>After entering your account and playing, these online casinos will offer you welcome bonuses.
1xBook provides a variety of introductory bonuses for their live casino events, ranging in value
from 100% matched bonuses up to Rs. 60,000 for Cricket Roulette. In comparison, you may get
an Rs. 3000 welcome bonus credit at the Bollywood Blackjack table.</p>
<p>High-end Welcome Casino Bonuses provided by {DOMAINDISPLAY.name} have established a new benchmark.
After making their initial minimal INR 100 investment, all new users of the online casino platform
get a 100% casino bonus. Because it is a one-time promotion, you should make the most of it.</p>
<p>These are a few welcome incentives from India's most well-known and reputable online
bookmakers. We advise you to click on the inbound links that will take you directly to the terms
and conditions page for welcome bonuses if you want to learn more about the welcome bonuses
offered by these casinos.</p>

<h2>How to maximize your profits while betting online in India?</h2>
<p>Playing online casino games, slot machines, and other games may all be a tonne of fun. They will
significantly increase your adrenaline levels, and you may feel inclined to spend more money
than is reasonable on these games. You must always keep fun out of these situations and
concentrate on your abilities. You need to have good betting abilities to increase your chances of
winning. You can't always rely on good fortune.</p>
<p>Know your sport well and out before placing a wager. Learn anything that seems significant and
may aid you in making accurate forecasts. For instance, if a football game is about to start, find
out who is participating, the starting lineup, the player types, the strengths and weaknesses of
the teams and the players, and their past performances. You may continue producing accurate
forecasts ahead of time with the help of all this knowledge.</p>
<p>Examine your chances of winning the wager at several bookies. You must diversify your contacts
since you can't always rely on one. Gain as many promos as possible, and use the site prediction
features. Do not rely on online predictions of winners. Create your forecasts to be specific.</p>
<p>Visit several betting websites to review betting deals, promotions, bonuses, incentives, welcome
bonuses, and the like. Open several betting accounts to make the most money from online
betting in India. But keep in mind to exercise discipline and refrain from impulsively placing bets.
Before making a wager, think it out thoroughly. Never wager with money you can't afford to lose.</p>

<h2>How can I deposit and withdraw funds while betting online?</h2>
<p>Deposit on the online betting site before you may place bets or take advantage of welcome
incentives. Navigate to the cashier portion of an online betting site to make a deposit. Examine
the forms of payment they take and see whether you have any of them. The most popular
payment options accepted by Indian online bookmakers are Paytm, Google Pay, debit/credit
cards, net banking, UPI, and others. All bookies allow international payment options, including
Mastercard and Visa, worldwide. It's best to verify beforehand since approved payment methods
differ from site to site.</p>
<p>Before you may withdraw money from online betting sites, several criteria, restrictions, and
demands must be satisfied. You must submit a few documents to complete your KYC and ID
verification. Compared to deposit payment methods, withdrawal payment methods might
sometimes have fewer payment options. The minimum and maximum withdrawal amounts vary
across various online bookmakers.</p>

<h2>Various forms of internet betting</h2>
<p>Most online bets are made on sports or athletic events, including basketball, association football,
horse racing, and cricket. Various bets may be made on award ceremonies, including the
Grammys, Oscars, Emmys, and others. Internet betting has been made more engaging to draw in
more players. So far, it has been confirmed to be a thriving sector that generates billions of
dollars annually. Learn about the sports events and sports you may bet on before placing an
online wager on any sporting event. What are the games with the lowest winning odds and the
most often played ones?</p>

<h3>Baseball betting</h3>
<p>In India, cricket betting may be the most popular internet gambling. With the advent of the Indian
Premier League, cricket betting became ten times more popular, and now, it enjoys significant
client engagement throughout ODI, Twenty20, and Test Matches.</p>
<p>Cricket is an unpredictable game, which makes it difficult to make accurate forecasts, but it also
makes it very entertaining. Learn about the strengths and weaknesses of the players on both
sides, the records of both teams, the spin and speed combinations, the present form of the
players, the squad composition, and the pitch report to broaden your understanding of cricket
betting and boost your chances of winning.</p>
<p>Determine the game's worth and choose the best bookies to put your bets on. Given the number
of active online cricket betting sites, you must choose wisely based on each one's minimal odds,
benefits, and promotions. Before a cricket match, the best advice is to go through all of the top
Indian online betting sites, review the latest news and betting trends, and then choose the one
that will be the safest and most advantageous.</p>
<p>On their website, {DOMAINDISPLAY.name} includes a section devoted to all cricket-related online betting and
casino events. They provide intriguing deals with their single and combination betting systems
and {DOMAINDISPLAY.name}. Betting on the Tamil Nadu Premier League is also available since they serve an
Indian audience.</p>
<p>These are a few of the cricket betting promotions that are currently available on various betting
platforms.</p>

<h3>Sports betting</h3>
<p>Soccer, or association football, is a global sport that is very well-liked all over the globe. Millions
of people watch competitions like the UEFA Euros, World Cup, UEFA Champions League, and
Premier League. Several online betting services also host tournaments to accurately predict the
number of goals each side scores and who will win the game after 90 minutes. Some online
bookmakers even provide advice to assist users in making accurate predictions.</p>
<p>However, you can't always rely on these forecasts; you must also be familiar with the game. Learn
about the playing styles, individual and team strengths and weaknesses, and who is most likely to
score a goal, among other things. You can create accurate forecasts if you sufficiently understand
all the game's contributing components.</p>
                              
 <h3>equine betting</h3>
 <p>You may have seen movie horse betting scenes where the wealthy, royalty and regular people
predict which horse will win. Horse betting competitions are a unique event in rich countries and
a fantastic way for people from the middle and lower-income classes to earn additional money by
making the correct predictions</p>
 <p>Knowing a horse's present form and health, as well as how they have fared in past races and how
the event ranks them, are necessary for making a good horse betting prediction. You may always
visit 1xBook.com if you want to wager on horses or horse races. 1xBook provides betting on horse
races in local and foreign markets.</p>

<h3>Basketball betting</h3>
<p>The Pro Kabaddi League event has increased interest in and interest in Kabaddi's all-Indian,
dynamic, and fascinating sport. Why not try Kabaddi Betting if you are an enthusiastic follower of
the Pro Kabaddi League and have a solid understanding of Kabaddi's rules and playing style? Use
your forecasts to your advantage and pick the best wagers on the match. The additional funds
from the victory will appear excellent on your bank statement.</p>
<p>If you're interested in betting on Kabaddi, check out 1xBook. That has a wide range of Kabaddi
betting choices.</p>

<h3>Basketball wagers</h3>
<p>Basketball wagering is mainly concentrated on the NBA, an international phenomenon. People
worldwide have expressed their admiration for the NBA, which has played a significant role in
American culture. Online wagering on these events is relatively standard, and even fantasy
basketball attracts some interest from bettors. The Euroleague is a different basketball
competition that is well-liked.</p>
<p>You may visit 1xBook to place a wager on Basketball sports events. 1xBook offers you the
opportunity to wager on events including WNBA friendlies, the NBA, Euroleague, Liga ACB
(Spain), and the BBL (Germany).</p>

<h2>Others</h2>
<p>Online bookmakers develop a particular platform for wagering on athletic events like the
Olympics, World Championships, Football World Cup, Cricket World Cup, and more when they
take place. You may browse the live Olympic betting homepage provided by {DOMAINDISPLAY.name} online
betting platform, make your prediction, and place bets on the currently playing sports. There are
several additional forms of online betting, such as cycling, Formula 1, boxing, wrestling,
badminton, hockey, esports, and more.</p>

<h2>Advice & Methods</h2>
<p>If you're new to online betting, you must learn to regulate your emotions and keep them out of
your play and wagering. Make intelligent estimates if you want to take a chance on losing your
money. Know what you are betting on and how many wins you can tolerate losing and winning.
After a game of online betting, you do not want to be left sitting on anything.</p>
<p>Do thorough research before placing a wager and look at historical patterns and results.
Consider learning more about online betting than simply the basics. For a sample, if you are
placing a bet on an Indian Premier League match, look into the prior results of both teams, as well
as the runs and actions of certain cricket players. You'll be able to place a more educated wager
and improve your chances of winning.</p>
<p>We advise you to visit and explore the websites before making bets if you want to use one of the
top Indian online betting sites mentioned above. You won't have to waste time looking for
possibilities and lose the necessary time that you might be used to placing bets.</p>
<p>We also suggest you go through the patterns, outcomes, and other data shown on the betting
websites. It will be simpler for you to play games and make money if you are more
knowledgeable about the most recent events in online gambling. Verify their legitimacy and how
they conduct financial transactions.</p>
<p>Open several betting accounts and take advantage of bonus and incentive offers. Before taking
the incentives, carefully review the terms and conditions. Be as acquainted with games as you
can with your odds of winning, and avoid gambling with funds you cannot afford to lose. You can
never predict whether or not luck will be on your side. Calculate the likelihood that you will win
vs. lose.</p>
<p>One of the most meaningful elements of online gambling is the time of bet placement. If there are
any active bets, check them out. To gain fascinating possibilities and prizes, you must be well
informed about your game. Look for tempting wagering opportunities. When betting online,
single bets are the most popular choice. Although there are dangers and benefits unique to this
situation, winning is more straightforward. To win single bets, you only need a thorough
understanding of the game and a dash of good fortune.</p>
<p>Keep a record of your wagering choices across different sites. You'll place better bets if you keep
a record of all your wagers, forecasts, and information on the game's status and specifics.
Additionally, you may monitor your spending and determine which kind of online betting will bring
you the most money.</p>
<p>Talk about the games with other online gamblers and sports fans. They'll increase your
understanding, but you may also gain from their comments and counsel.</p>

<h2>The evolution of internet betting</h2>
<p>Sports betting has been around for a very long time, and it possibly got its start with gladiator
fights in ancient Greece. Online gambling started to become popular soon after the internet was
invented. The three most popular types of internet gambling—poker, casinos, and sports
betting—have brought a lot of money into their systems. Online sports betting is the most
common type of gambling available globally. You can gain money if you can correctly forecast a
game, wager on the result, and make good predictions.</p>
<p>Online betting is shared globally, but it is trendy in sports like football, American football,
basketball, horse racing, and wrestling. You may utilize your understanding of these games to
gain money if you like sports and want to start placing bets online.</p>
<p>Additionally, there are several scandals and issues surrounding online betting. Before placing a
wager on a sport, it would be prudent to do a considerable study about its history. While placing
bets online, you do not want the threat of loss to hang over your head.</p>

<h2>Legality</h2>
<p>Before engaging in internet gambling, you should familiarise yourself with your state laws since
the state governs gaming. The rules governing gambling and betting in India differ from state to
state. To prevent engaging in any unlawful acts with knowledge, it is preferable to do some
research. Casinos and gambling, both online and off, are permitted in several states, including
Goa and Sikkim, and they significantly boost those states' economies.</p>
<p>We may infer that internet gambling is undoubtedly legal in India on a greater scale. Only a few
states have laws limiting internet gambling, betting, and casinos out of all those in the union.
However, it is best to confirm the legitimacy of these online gambling sites before putting your
bets if you want to be certain.</p>



</div>
                        </div>
                    </div>
                </section>
                </>
            }
            </div>
            <Loginb2cFooter history={this.props.history} selectedSection={this.state.selectedSection} toggleSelectedSection={(view) => this.toggleSelectedSection(view)} showSweetAlert={(options) =>this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cFooter>
           
       
            
            {this.state.showSplashScreenPopup && <SplashScreenModal hidePopup={() => { this.hideSplashScreenPopup() }} />}
        </div>
        :
        <UnderMaintenance inMaitanenceMessage={this.state.inMaitanenceMessage} />
        }
        </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginB2C);